import React from "react";
import { Button, Typography } from "antd";

const ResourcesPageTitle: React.FC = () => {
  const handleContactSupport = () => {
    const email = "support@qualifyme.ai";
    const subject = encodeURIComponent("Support Request");
    const body = encodeURIComponent(
      `I’m reaching out because I need some help with the QualifyMe platform

Best regards`
    );

    let mailClientOpened = false;
    const handleWindowBlur = () => {
      mailClientOpened = true;
      window.removeEventListener("blur", handleWindowBlur);
    };
    window.addEventListener("blur", handleWindowBlur);

    // Attempt to open the mail client
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;

    // Fallback to Gmail if the mail client doesn't open
    setTimeout(() => {
      window.removeEventListener("blur", handleWindowBlur);
      if (!mailClientOpened) {
        const fallbackGmailUrl = `https://mail.google.com/mail/?view=cm&to=${email}&su=${subject}&body=${body}`;
        const newTab = window.open(
          fallbackGmailUrl,
          "_blank",
          "noopener,noreferrer"
        );
        newTab?.focus();
      }
    }, 750);
  };

  return (
    <div
      className="resources-page-title"
      style={{ display: "flex", alignItems: "center", gap: "12px" }}
    >
      <Typography.Title level={4} style={{ margin: 0 }}>
        Resources
      </Typography.Title>
      <Button type="primary" onClick={handleContactSupport}>
        Contact Support
      </Button>
    </div>
  );
};

export default ResourcesPageTitle;
